<jhi-spinner *ngIf="loading"></jhi-spinner>
<jhi-alert></jhi-alert>
<div
  class="row"
  joyrideStep="primoStepHome"
  [stepContent]="primoStep"
  [nextTemplate]="nextButton"
  [prevTemplate]="prevButton"
  [doneTemplate]="doneButton"
>
  <div class="container-fluid" *ngIf="!loading">
    <div class="row justify-content-center">
      <div class="col-sm-3 text-center">
    <nav [ngClass]="{ toolbar: !mobile }" class="my-5 mx-1 align-items-center">
    <ul *ngIf="showServiceNavBar" style="list-style-type: none; align-items: unset" class="ms-4">
      <li (click)="formPatchValue('Tutti i servizi', -1)" class="growToolbar text-color-hover-underline icon-hover">
        <a [ngClass]="{ '': 'Tutti i servizi' === getServizio() }" class="text-color-hover-underline">
          <svg class="icon-sm" style="height: 64px; width: 64px; vertical-align: middle"
               [ngClass]="{ 'icon-color': 'Tutti i servizi' === getServizio() }">
            <use href="./content/svg/sprites.svg#it-list"></use>
          </svg>
          <span class="toolbar-label fw-bolder navService "
                [ngClass]="{ 'text-color': 'Tutti i servizi' === getServizio() }">Tutti i servizi</span>
          <span class="toolbar-label navService"
                [ngClass]="{ 'text-color': 'Tutti i servizi' === getServizio() }">{{numServiziTot}} Servizi</span>
        </a>
      </li>
      <li (click)="formPatchValue('Cassetto del cittadino', -2)"
          class="growToolbar text-color-hover-underline icon-hover">
        <a [ngClass]="{ '': 'Cassetto del cittadino' === getServizio() }" class="text-color-hover-underline">
          <svg class="icon-sm" style="height: 64px; width: 64px; vertical-align: middle"
               [ngClass]="{ 'icon-color': 'Cassetto del cittadino' === getServizio() }">
            <use href="./content/svg/sprites.svg#it-inbox"></use>
          </svg>
          <span class="toolbar-label fw-bolder navService "
                [ngClass]="{ 'text-color': 'Cassetto del cittadino' === getServizio() }">Cassetto del cittadino</span>
          <!-- <span class="toolbar-label navService" [ngClass]="{ 'text-color': 'Cassetto del cittadino' === getServizio() }">{{numServiziTot}} Servizi</span> -->
        </a>
      </li>
      <li class="toolbar-divider mt-3"></li>
    </ul>
    </nav>
      </div>
      <div class="col-sm-9 col-md-8 col-lg-7 col-xxl-6 ms-5">
        <splide [options]="{perPage: 3}">
          <splide-slide *ngFor="let service of servicesStorage; index as i">
            <div class="text-center mt-5 pb-2">
              <div
                class="growToolbar text-color-hover-underline icon-hover"
                [ngClass]="{'d-none': service.nmServizio === 'Attività'}"
                (click)="formPatchValue(service.nmServizio, i)"
              >
                <a [ngClass]="{ '': service.nmServizio === getServizio() }" class="text-color-hover-underline">
                  <svg class="icon-xs" style="height: 58px; width: 58px; vertical-align: middle"
                       [ngClass]="{ 'icon-color': service.nmServizio === getServizio() }">
                    <use [attr.xlink:href]="'.'+service.nmSvg"></use>
                  </svg>
                  <p class="toolbar-label fw-bolder navService mb-1"
                     [ngClass]="{ 'text-color': service.nmServizio === getServizio() }">{{
                    service.nmServizio
                    }}</p>
                  <p class="toolbar-label navService" [ngClass]="{ 'text-color': service.nmServizio === getServizio() }"
                  >{{ service.numFunzioniServizio }} Servizi</p
                  >
                </a>
              </div>
            </div>
          </splide-slide>
        </splide>
      </div>
    </div>
    <!--<div class="w-50 mt-5">
      <div class="form-group autocomplete-wrapper-big mb-3" style="left:50%">
        <label for="autocomplete-regioni" class="visually-hidden">Cerca nel sito</label>
        <input (focus)="apriQueryModal()" (focusout)="rimuoviQueryModal()" class="autocomplete" autocomplete="off"
               #INPUT_SEARCH (input)="searchInputChange($event)" type="search" placeholder="Cerca per argomento"
               id="autocomplete-regioni">
        <span class="autocomplete-icon" aria-hidden="true"><svg class="icon icon-sm icon-color"><use
          href="./content/svg/sprites.svg#it-search"></use></svg></span>
        <div #DIV_MODAL_OPENER class="dropdown-menu" style="margin-top: 10px;" data-bs-toggle="dropdown"
             aria-haspopup="true" aria-expanded="false">
          <div class="link-list-wrapper p-1">
            <ul class="link-list" *ngIf="result && result.length > 0; else noRes">
              <li *ngFor="let res of result">
                <svg class="icon">
                  <use [attr.xlink:href]="res?.nmSvg"></use>
                </svg>
                {{res?.nmServizio}}
                <ul (mouseout)="mouseOverModal=false" (mouseover)="mouseOverModal = true">
                  <li *ngFor="let fs of res?.funzioniServizio">
                    <a
                      (click)="fs.codice ? routingTributi(navService.navRouting.get(fs.nmComponent), fs) : routing(fs.nmComponent)"
                      class="dropdown-item list-item">
                      <span>{{fs?.nmTitolo}}</span>
                    </a>
                  </li>
                </ul>
              </li>
            </ul>
            <ng-template #noRes>
              <ul>
                <li>
                  <a>
                    <svg class="icon icon-warning">
                      <use href="./content/svg/sprites.svg#it-warning-circle"></use>
                    </svg>
                    <span class="text-secondary align-middle text-decoration-none">La ricerca non ha prodotto alcun risultato</span>
                  </a>
                </li>
              </ul>
            </ng-template>
          </div>
        </div>
      </div>
    </div> -->
  </div>

  <div class="row pe-0">
    <div class="col-12 pe-0">
      <div class="card-responsive card-service bg-grey-card">
        <!--start card-->
        <div joyrideStep="terzoStepHome" [stepContent]="terzoStep" [nextTemplate]="nextButton"
             [prevTemplate]="prevButton">
          <div
            class="container-fluid w-100"
            style="display: flex; flex-wrap: wrap; justify-content: center; align-items: center"
            *ngFor="let card of servicesStorage">
            <div
              class="col-12 col-xxl-10"
              style="margin-left: 10px; margin-right: 10px"
              *ngFor="let funzione of card.funzioniServizio">
              <div *ngIf="card.nmServizio == getServizio()">
                <div class="cmp-card-latest-messages mb-3 mb-30">
                  <div class="card px-4 pt-4 pb-4 rounded"
                       *ngIf="funzione.nmTitolo == 'Prenota Appuntamento' && getServizio() !== 'Tutti i servizi'">
                    <div class="card-header border-0 p-0">
                      <div class="text-decoration-none title-xsmall-bold mb-2 category text-uppercase">
                        <svg class="icon icon-color">
                          <use href="./content/svg/sprites.svg#it-file"></use>
                        </svg>
                        <span class="fs-title">{{ card.nmServizio }}</span>
                      </div>
                      </div>
                    <div class="card-body p-0 my-2">
                      <a (click)="routing(funzione.nmComponent)">
                        <h5 class="fs-6 mb-8"
                            title="{{ funzione.nmTitolo }}">{{ funzione.nmTitolo }}</h5>
                      </a>
                      <button
                        class="btn btn-xs btn-primary primary-button mt-4 custom-button"
                        (click)="routing(funzione.nmComponent)"
                        joyrideStep="quartoStepHome"
                        [stepContent]="quartoStep"
                        [nextTemplate]="nextButton"
                        [prevTemplate]="prevButton"
                        [doneTemplate]="doneButton"
                      >
                        Accedi al servizio
                      </button>
                    </div>
                  </div>
                  <div class="card px-4 pt-4 pb-4 rounded"
                       *ngIf="funzione.nmTitolo != 'Prenota Appuntamento' && getServizio() !== 'Tutti i servizi' || funzione.nmTitolo != 'Prenota Appuntamento' && getServizio() !== 'Cassetto del cittadino'">
                    <div class="card-header border-0 p-0">
                      <div class="text-decoration-none title-xsmall-bold mb-2 category text-uppercase">
                        <svg class="icon icon-color">
                          <use href="./content/svg/sprites.svg#it-file"></use>
                        </svg>
                        <span class="fs-title">{{ card.nmServizio }}</span>
                      </div>
                    </div>
                    <div class="card-body p-0 my-2">
                      <a (click)="funzione.codice
                          ? routingTributi(navService.navRouting.get(funzione.nmComponent), funzione)
                          : routing(funzione.nmComponent)">
                        <h5 class="fs-6 mb-8"
                            title="{{ funzione.nmTitolo }}">{{ funzione.nmTitolo }}</h5>
                      </a>
                      <button
                        class="btn btn-xs btn-primary primary-button mt-4 custom-button"
                        (click)="
                          funzione.codice
                            ? routingTributi(navService.navRouting.get(funzione.nmComponent), funzione)
                            : routing(funzione.nmComponent)
                        "
                      >
                        Accedi al servizio
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="container-fluid w-100">
            <div class="row">
              <div *ngIf="'Tutti i servizi' == getServizio()" class="col-xxl-3 ps-lg-5 pb-md-4 pb-sm-4 order-first order-xxl-last">
                <div class="link-list-wrap">
                  <h2 class="title-xsmall-semi-bold"><span>SERVIZI IN EVIDENZA</span></h2>
                  <ul class="link-list text-primary">
                    <li class="mb-3 mt-3" *ngFor="let serv of servInEvidenza">
                      <a class="list-item ps-0 title-medium" (click)="serv.codice
                          ? routingTributi(navService.navRouting.get(serv.nmComponent), serv)
                          : routing(serv.nmComponent)">
                        <span>{{serv.nmTitolo}}</span>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="col-xxl-8 pt-2">
                <div class="d-flex flex-wrap">
                  <ng-container *ngIf="'Tutti i servizi' == getServizio()">
                    <div class="col-lg-12">
                    <div class="cmp-input-search">
                    <div class="form-group autocomplete-wrapper mb-2 mb-lg-4">
                      <div class="input-group">
                        <label for="autocomplete-autocomplete-three" class="visually-hidden active">Cerca una parola chiave</label>
                        <input type="search" class="autocomplete form-control" placeholder="Cerca un servizio" id="autocomplete-autocomplete-three" name="autocomplete-three" data-focus-mouse="false" (input)="searchAllServ($event.target)"><ul class="autocomplete-list"></ul>

                        <div class="input-group-append">
                          <button class="btn btn-primary" type="button" id="button-3">Invio</button>
                        </div>

                        <span class="autocomplete-icon" aria-hidden="true">
                      <svg class="icon icon-sm icon-primary">
                        <use href="content/svg/sprites.svg#it-search"></use>
                      </svg>
                    </span>
                      </div>
                    </div>
                    </div>
                    </div>
                    <div class="col-lg-12">
                    <p><strong *ngIf="allServ">{{allServ.length}} </strong>servizi trovati in ordine alfabetico</p>
                    </div>
                    <ng-container>
                      <div class="col-12" *ngFor="let funzione of allServ">
                        <div>
                          <div class="cmp-card-latest-messages mb-3 mb-30">
                            <div class="card px-4 pt-4 pb-4 rounded">
                              <div class="card-header border-0 p-0">
                                <div class="text-decoration-none title-xsmall-bold mb-2 category text-uppercase">
                                  <svg class="icon icon-color">
                                    <use href="./content/svg/sprites.svg#it-file"></use>
                                  </svg>
                                  <span class="fs-title">{{ funzione.macroArea }}</span>
                                </div>
                                </div>
                              <div class="card-body p-0 my-2">
                                <a (click)="funzione.codice
                          ? routingTributi(navService.navRouting.get(funzione.nmComponent), funzione)
                          : routing(funzione.nmComponent)">
                                  <h3 class="fs-6 mb-8"
                                      title="{{ funzione.nmTitolo }}">
                                    {{ funzione.nmTitolo }}
                                  </h3>
                                </a>
                                <button
                                  class="btn btn-xs btn-primary primary-button mt-4 custom-button"
                                  (click)="
                        funzione.codice
                          ? routingTributi(navService.navRouting.get(funzione.nmComponent), funzione)
                          : routing(funzione.nmComponent)
                      "
                                >
                                  Accedi al servizio
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </ng-container>
                  </ng-container>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div>
        <button class="btn btn-secondary btn-xs btn-tour" (click)="onTour()">Aiuto</button>
      </div>
      <ng-template #nextButton>
        <button class="btn btn-xs btn-primary" jhiTranslate="tour.button.nextButton">Vai avanti</button>
      </ng-template>
      <ng-template #prevButton>
        <button class="btn btn-xs btn-primary" jhiTranslate="tour.button.prevButton">Torna Indietro</button>
      </ng-template>
      <ng-template #doneButton>
        <button class="btn btn-xs btn-success" jhiTranslate="tour.button.doneButton">Fine</button>
      </ng-template>
      <ng-template #primoStep>
        <h3 jhiTranslate="tour.home.primoStep-h3">Questa è la barra dei servizi</h3>
        <p jhiTranslate="tour.home.primoStep-p">Da qui puoi selezionare tutti i servizi disponibili</p>
      </ng-template>
      <ng-template #secondoStep>
        <h3 jhiTranslate="tour.home.secondoStep-h3">La freccia permette di scorrere tra i servizi</h3>
        <p jhiTranslate="tour.home.secondoStep-p">Premi per visualizzare i restanti servizi disponibili</p>
      </ng-template>
      <ng-template #terzoStep>
        <h3 jhiTranslate="tour.home.terzoStep-h3">
          Selezionando una categoria verranno visualizzati tutti i servizi disponibili per quella categoria
        </h3>
        <p jhiTranslate="tour.home.terzoStep-p">Selezionando "Tutti i servizi" verrò mostrato ogni servizio
          disponibile</p>
      </ng-template>
      <ng-template #quartoStep>
        <h3 jhiTranslate="tour.home.quartoStep-h3">
          Ogni servizio può essere raggiunto premendo il bottone "Accedi al servizio" associato
        </h3>
        <p jhiTranslate="tour.home.quartoStep-p">Premi per accedere al servizio</p>
      </ng-template>
    </div>
  </div>
</div>
